import { classNames } from "../../style/common"

export type SimpleProgressProps = {
  progress: number,
  classNames?: {
    container?: string,
    bar?: string
  }
}

export default function SimpleProgress(props: SimpleProgressProps) {
  return (
    <div className={classNames(props.classNames?.container)}>
      <div className="overflow-hidden rounded-full bg-gray-200">
        <div className={classNames("h-2 rounded-full bg-indigo-600", props.classNames?.bar)} style={{ width: `${props.progress}%` }} />
      </div>
    </div>
  )
}
